/**
 * Restore the source language after GTranslate resets it to "auto".
 *
 * Valid translated language codes are left untouched.
 */
( function () {
	const hostname = window.location.hostname.toLowerCase();
	let sourceLanguage = null;

	if ( hostname === 'thermotile.gr' || hostname.endsWith( '.thermotile.gr' ) ) {
		sourceLanguage = 'el';
	} else if ( hostname === 'thermotile.al' || hostname.endsWith( '.thermotile.al' ) ) {
		sourceLanguage = 'sq';
	}

	if ( ! sourceLanguage ) {
		return;
	}

	const html = document.documentElement;

	function correctAutomaticLanguage() {
		if ( html.getAttribute( 'lang' ) === 'auto' ) {
			html.setAttribute( 'lang', sourceLanguage );
		}
	}

	new MutationObserver( correctAutomaticLanguage ).observe( html, {
		attributes: true,
		attributeFilter: [ 'lang' ],
	} );

	correctAutomaticLanguage();
}() );
